module.exports = __webpack_public_path__ + "static/media/咖哩海鮮燴炒.d8db81a8.jpg";